import mod from "-!./footer_component.js?vue&type=script&lang=js&"; export default mod; export * from "-!./footer_component.js?vue&type=script&lang=js&"